import _ from 'lodash'
import RequestError from './RequestError'
import api from '@/api'

export default {
	initPaywall,
    stripeLinkingStatus,
	getStreamPaywall,
    activateStreamPaywall,
    updateStreamPaywall,
	getPaywall,
	getTransactions,
	getUsers,
	getPaywallStreams,
	getPaywallFinancialReport,
	refundPayment,
	paywallUploadLogo,
	paywallUploadPoster,
	updatePaywallSettings,
	getTemporaryLinks,
	createTemporaryLink,
	getPaywallStreamSource,
	getSourceTransactions,
	updateStreamPaywallSource,
	toggleStreamPaywall,
	deleteStreamPaywall,
	unlinkPaywall,
	updateStreamPaywallById,
	updatePaywallInternalName,
	updatePaywallAccessFrom,
	toggleStreamPaywallPopupAuth,
	addPaywallEmailAccess,
	removePaywallEmailAccess,
	getPromoCodes,
	createPromoCode,
	getPromoCode,
	updatePromoCode,
	deletePromoCode,
	getPromoRedemptions,
	getEmailTemplates,
	getEmailTemplate,
	updateEmailTemplate,
	deleteEmailTemplate,
	previewEmailTemplate
}

function getPromoRedemptions(id) {
	return makeRequest(`/paywall/promo/${id}/redemptions`)
}

function getEmailTemplates() {
	return makeRequest(`/paywall/email-templates`)
}

function getEmailTemplate(key) {
	return makeRequest(`/paywall/email-templates/${key}`)
}

function updateEmailTemplate(key, payload) {
	return makeRequest({
		method: 'put',
		path: `/paywall/email-templates/${key}`,
		data: payload
	})
}

function deleteEmailTemplate(key) {
	return makeRequest({
		method: 'delete',
		path: `/paywall/email-templates/${key}`
	})
}

function previewEmailTemplate(key, payload) {
	return makeRequest({
		method: 'post',
		path: `/paywall/email-templates/${key}/preview`,
		data: payload || {}
	})
}

function getPromoCodes() {
	return makeRequest(`/paywall/promo`)
}

function createPromoCode(payload) {
	return makeRequest({
		method: 'post',
		path: `/paywall/promo`,
		data: payload
	})
}

function getPromoCode(id) {
	return makeRequest(`/paywall/promo/${id}`)
}

function updatePromoCode(id, payload) {
	return makeRequest({
		method: 'put',
		path: `/paywall/promo/${id}`,
		data: payload
	})
}

function deletePromoCode(id) {
	return makeRequest({
		method: 'delete',
		path: `/paywall/promo/${id}`
	})
}

function removePaywallEmailAccess(streamId, id, email) {
	return makeRequest({
		method: 'delete',
		path: `/paywall/${streamId}/removeEmailAccess`,
		data: { email, id }
	})
}

function addPaywallEmailAccess(streamId, email) {
	return makeRequest({
		method: 'post',
		path: `/paywall/${streamId}/grantEmailAccess`,
		data: { email }
	})
}

function updateStreamPaywallById(streamId, payload) {
	return makeRequest({
		method: 'post',
		path: `/paywall/${streamId}/update/byId`,
		data: payload
	})
}

function updatePaywallInternalName(streamId, name) {
	return makeRequest({
		method: 'post',
		path: `/paywall/${streamId}/internalName`,
		data: { name }
	})
}

function updatePaywallAccessFrom(streamId, accessFrom) {
	return makeRequest({
		method: 'post',
		path: `/paywall/${streamId}/accessFrom`,
		data: { accessFrom }
	})
}

function unlinkPaywall(full = false) {
	return makeRequest({
		method: 'delete',
		path: full ? `/paywall?mode=full` : `/paywall`,
	})
}

function deleteStreamPaywall(streamId) {
	return makeRequest({
		method: 'delete',
		path: `/paywall/${streamId}/`,
	})
}

function toggleStreamPaywall(streamId) {
	return makeRequest({
		method: 'put',
		path: `/paywall/${streamId}/toggle`,
		data: {}
	})
}

function toggleStreamPaywallPopupAuth(paywall, conflictCheck = false) {
	return makeRequest({
		method: 'put',
		path: `/paywall/${paywall}/toggle/popupAuth${conflictCheck ? '?conflictCheck=true' : ''}`,
		data: {}
	})
}

function updateStreamPaywallSource(id, sourceId, payload) {
	return makeRequest({
		method: 'put',
		path: `/paywall/source/${id}/${sourceId}`,
		data: payload
	})
}

function getPaywallStreamSource(id) {
	return makeRequest(`/paywall/source/${id}`)
}

function createTemporaryLink(streamId, expireAt, expireMin) {
	return makeRequest({
		method: 'post',
		path: `/paywall/${streamId}/temporaryLink?expireAt=${expireAt}&expireMin=${expireMin}`,
		data: {}
	})
}

function getTemporaryLinks(streamId) {
	return makeRequest(`/paywall/${streamId}/temporaryLinks`)
}

function getUsers() {
	return makeRequest(`/paywall/stat/users`)
}

function updatePaywallSettings(payload, source = false) {
	return makeRequest({
		method: 'post',
		path: `/paywall/settings/metadata${source ? '?sourceId=' + source : ''}`,
		data: payload
	})
}

function paywallUploadLogo(fdata, source = false) {
	return makeRequest({
		path: `/paywall/settings/logoUpload${source ? '?sourceId=' + source : ''}`,
		method: 'post',
		data: fdata,
		headers: {
			'content-type': 'multipart/form-data'
		}
	});
}

function paywallUploadPoster(fdata, source) {
	return makeRequest({
		path: `/paywall/settings/logoUpload?target=poster${source ? '&sourceId=' + source : ''}`,
		method: 'post',
		data: fdata,
		headers: {
			'content-type': 'multipart/form-data'
		}
	});
}

function refundPayment(paymentId) {
	return makeRequest({
		method: 'post',
		path: `/paywall/payment/${paymentId}/refund`,
		data: {}
	})
}

function getPaywallFinancialReport() {
	return makeRequest(`/paywall/stat/financialReport`)
}

function getPaywallStreams(sort = 'asc') {
	return makeRequest(`/paywall/streams?sort=${sort}`)
}

function getTransactions() {
	return makeRequest(`/paywall/stat/transactions`)
}

function getSourceTransactions(id) {
	return makeRequest(`/paywall/stat/${id}/transactions`)
}

function getPaywall() {
	return makeRequest(`/paywall/info`)
}

function initPaywall() {
	return makeRequest({
		method: 'post',
		path: '/paywall/init',
		data: {}
	})
}

function activateStreamPaywall(streamId, payload) {
	return makeRequest({
		method: 'post',
		path: `/paywall/${streamId}/`,
		data: payload
	})
}

function updateStreamPaywall(streamId, payload, videoId = false) {
	return makeRequest({
		method: 'post',
		path: `/paywall/${streamId}/update${videoId ? '?videoId=' + videoId : ''}`,
		data: payload
	})
}

function stripeLinkingStatus() {
	return makeRequest('/paywall/activationStatus')
}

function getStreamPaywall(streamId) {
	return makeRequest(`/paywall/${streamId}/info`)
}

async function makeRequest(reqConfig) {
	if (typeof reqConfig === 'string') {
		reqConfig = {
			path: reqConfig
		}
	}

	reqConfig.url = reqConfig.path

	let res
	try {
		res = await api.request(reqConfig)
	} catch (err) {
		let edata = _.get(err, 'response.data')
		throw new RequestError(edata)
	}

	return res.data
}